(function () {
    'use strict';

    angular
        .module('corporateRoleModule', [
        ]);
})();